package kz.dentalcrm.app.core.storage

import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings

actual fun Settings(): Settings = StorageSettings()
